import { defineComponent, handleApiError, IOmniaShell, selectMany } from "../../omnia"
import { SatelliteApi } from "../api"
import { SatelliteContext } from "../context"
import { ImageryProviderId } from "../providers"
import { SatImageType } from "../types"
import { createState, Cropping, Group, selectCropping, selectGroup, setSelectedCropping, State } from "./state"

export class LayersCtrl {

    static create(): ng.IDirective {
        return defineComponent(LayersCtrl, "app/datalayers/satellite/layers/layers.html", {
            context: "="
        })
    }

    context: SatelliteContext

    private api: SatelliteApi
    private date: Date
    private providerId: ImageryProviderId
    private imageType: SatImageType

    private state: State

    public groups: Group[]

    static $inject = ["$scope", "OmniaShell"]

    constructor($scope: ng.IScope, private readonly shell: IOmniaShell) {
    }

    $onInit() {

        const { api, date, providerId, imageType, imagery } = this.context

        this.api = api
        this.date = date
        this.providerId = providerId
        this.imageType = imageType

        const state = createState(api, imagery, date)

        const selectable = new Set(
            selectMany(state.groups.map(g => g.items.filter(i => i.canSelect).map(i => i.croppingId)))
        )

        this.context.map.enableSelection(
            true,
            f => selectable.has(f.croppingId),
            fields => this.setState(setSelectedCropping(this.state, fields))
        )

        this.setState(state)

    }

    setState(state: State) {
        this.state = state
        this.groups = state.groups
        this.context.map.setSelection(
            selectMany(state.groups.map(g => g.items.filter(i => i.canSelect && i.selected).map(i => i.cropping)))
        )
    }


    toggleCropping(group: Group, cropping: Cropping) {
        // Note: at this point, cropping.selected has already been changed by Angular, through the checkbox
        this.setState(selectCropping(this.state, group, cropping, cropping.selected))
    }

    toggleGroup(group: Group) {
        // Note: at this point, group.selected has already been changed by Angular, through the checkbox
        this.setState(selectGroup(this.state, group, group.selected))
    }

    unselectAll() {
        this.setState(setSelectedCropping(this.state, []))
    }

    cancel() {
        this.context.close(false)
    }

    commit() {

        const { providerId, imageType, date } = this
        const croppingIds = selectMany(this.groups.map(g => g.items.filter(i => i.selected).map(i => i.croppingId)))

        this.api.requestLayerCreation(providerId, imageType, date, croppingIds)
            .then(() => {
                // TODO: message
                this.context.close(true)
            })
            .catch(e => handleApiError(this.shell, e))

    }

    canCommit() {
        return this.groups?.some(g => g.selected)
    }

}
